import { render, staticRenderFns } from "./AscSegmentedButton.vue?vue&type=template&id=01d6972e&"
import script from "./AscSegmentedButton.vue?vue&type=script&lang=js&"
export * from "./AscSegmentedButton.vue?vue&type=script&lang=js&"
import style0 from "./AscSegmentedButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
